<template>
  <v-layout column>
    <v-toolbar color="secondary">
      <v-toolbar-title class="report-title font-weight-thin white--text">
        {{ admin.Name }}
        <strong>Admin</strong>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        class="adminButton"
        round
        @click="openForm('create')"
      >Add {{ admin.Name }}</v-btn>
      <v-btn color="primary" class="adminButton" round @click="readDocuments()">Refresh</v-btn>
    </v-toolbar>

    <v-layout rows>
      <v-flex xs12>
        <!-- navigation drawer - hide collumns - Start -->
        <v-navigation-drawer
          v-model="drawer"
          absolute
          temporary
          right
          light
          class="secondary lighten-3"
        >
          <v-list class="pa-1">
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>icons8-cog-wheel</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title style="font-size:20px !important">Hide fields</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>
          </v-list>
          <v-list style="margin-left: 10% !important; margin-bottom: 13% !important;">
            <v-list-tile-content>
              <v-checkbox
                v-for="(column, index) in Columns"
                :key="index"
                v-model="column.hidden"
                :label="column.label"
                :false-value="true"
                :true-value="false"
                primary
                style="max-height:27px !important; max-width: 150px !important;"
              ></v-checkbox>
            </v-list-tile-content>
          </v-list>
          <v-divider></v-divider>
          <v-layout justify-center>
            <v-btn
              color="white"
              light
              style="margin-top: 5% !important"
              @click.stop="drawer = !drawer"
            >Done</v-btn>
          </v-layout>
        </v-navigation-drawer>
        <!-- navigation drawer - hide collumns - End-->

        <!-- Vue Good Table - Start -->
        <vue-good-table
          ref="my-table"
          :columns="Columns"
          :rows="rows"
          :sort-options="SortOptions"
          :search-options="SearchOptions"
          :pagination-options="Pagination"
          style-class="vgt-table condensed bordered striped"
          row-style-class="tablerowheight"
        >
          <!--drawer button - hide collumns -->
          <div slot="table-actions">
            <v-btn outline fab small color="primary" right @click.stop="drawer = !drawer">
              <v-icon dark>icons8-cog-wheel</v-icon>
            </v-btn>
          </div>
          <template slot="table-column" slot-scope="props">
            <span class="tablerowheight">{{ props.column.label }}</span>
          </template>
          <!-- edit and delete options -->
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'action'">
            <v-icon color="primary" class="tableicon" @click="openForm('edit', props.row)">edit</v-icon>&nbsp;&nbsp;
            <v-icon color="primary" class="tableicon" @click="deleteDocument(props.row.id, props.row.name)">delete</v-icon>
            </span>
            <span v-if="props.column.type === 'array'" class="tablefont">
              <v-chip
                v-for="(item, index) in props.formattedRow[
                  props.column.field
                ]"
                :key="index"
              >{{ item }}</v-chip>
            </span>
            <span v-else class="tablefont">{{ props.formattedRow[props.column.field] }}</span>
          </template>
        </vue-good-table>
        <!-- Vue Good Table - End -->
      </v-flex>
    </v-layout>
    <v-dialog v-model="Dialog" max-height="70%" max-width="55%">
      <component
        :is="componentName"
        :form="Form"
        :portal="portal"
        :formaction="formAction"
        :admin="admin"
        :portallookups="portalLookups"
        :portallist="portalList"
        @Dialog="Dialog = $event"
      />
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
import "@/components/forms";

export default {
  props: {
    admin: {
      type: Object,
      default() {
        return {};
      }
    },
    schema: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data: () => ({
    hideColumns: [],
    portalList: [],
    portalLookups: [],
    formAction: "create",
    Form: {},
    Dialog: false,
    portalDialog: false,
    rows: [],
    Pagination: {
      enabled: true,
      mode: "records",
      perPage: 12,
      setCurrentPage: 1,
      position: "bottom",
      perPageDropdown: [5, 10, 20, 30, 40, 50],
      dropdownAllowAll: true,
      nextLabel: "Next",
      prevLabel: "Prev",
      rowsPerPageLabel: "Rows per page",
      ofLabel: "of",
      pageLabel: "Page", // for "pages" mode
      allLabel: "All"
    },

    SearchOptions: { enabled: true },
    SortOptions: {
      enabled: false
      // initialSortBy: { field: "id", type: "asc" }
    },
    drawer: null,
    isEditing: false,
    items: [
      { title: "Home", icon: "dashboard" },
      { title: "About", icon: "question_answer" }
    ]
  }),
  computed: {
    ...mapState({
      Portals: state => state.Admin.Portals,
      portal: state => state.portal,
      Documents: state => state.Admin.Documents,
      integration: state => state.integration
    }),
    Columns() {
      return this.schema.columns;
    },
    componentName() {
      return this.admin.Component;
    }
  },
  watch: {
    portal: {
      handler: function() {
        this.readDocuments();
        //console.log("watch.portal");
        this.readPortals();
      },
      deep: true
    },
    Portals: {
      handler: function() {
        this.portalList = this.Portals;
        //console.log("PortalWatch = " + JSON.stringify(this.Portals, null, 2));
      },
      deep: true
    },
    Documents: {
      handler: function() {
        this.rows = this.Documents;
        //console.log("Documents = " + JSON.stringify(this.Documents, null, 2));
        if (this.componentName == "portal") {
          this.rows = this.Portals;
        }
      },
      deep: true
    },
    DocumentResult: {
      handler: function() {
        this.readDocuments();
      },
      deep: true
    },
    admin: {
      handler: function() {
        this.readDocuments();
      },
      deep: true
    },
    Columns: {
      handler: function() {
        this.tableCol = this.Columns;
        if (this.componentName == "portal") {
          this.tableCol = this.Portals;
        }
        //console.log("Columns = " + JSON.stringify(this.Columns, null, 2));
        //console.log("Comp name " + this.componentName)
      },
      deep: true
    },
    Dialog() {
      this.readDocuments();
    },
    Form: {
      handler: function() {
      //console.log(JSON.stringify(this.Form, null, 2));
      },
      deep: true
    }
  },
  mounted() {
    this.readDocuments();
    //this.readPortals();
    this.$store.dispatch("portal/readLookups", [
      "lookups",
      this.portal.active.id,
      "portal/setLookups",
      "portal/setLookupsResult"
    ]);
  },
  methods: {
    hideColumn(i) {
      this.schema.columns[i].hidden = true;
    },
    readDocuments() {
      this.$store.dispatch("Admin/readDocuments", [
        this.admin.Collection,
        this.portal.active.id,
        "Admin/setDocuments"
      ]);
    },
    deleteDocument(id, name) {
      var confirm = window.confirm("Are you sure you want to delete this record?");
      if(confirm === true){
        this.$store.dispatch("Admin/deleteDocument", [
        this.admin.Collection,
        id,
        "Admin/setDocumentResult"
      ]);
      this.readDocuments();
      // console.log("delete Portal")
      this.readPortals();
      }
      else {
        //do nothing 
      }      
    },
    updateDocument() {
      this.$store.dispatch("Admin/updateDocument", [
        this.admin.Collection,
        this.Form.id,
        this.Form
      ]);
      this.readDocuments();
      // console.log("update Portal");
      this.readPortals();
    },
    openForm(action, record) {
      if (this.portal.active.id !== null) {
        switch (action) {
          case "create":
            this.Form = {};
            this.Form.portalID = [];
            this.Form.portalID.push(this.portal.active.id);
            this.Form.enabled = false;
            this.formAction = "create";
            this.Dialog = true;
            break;
          case "edit":            
            this.Form = record;
            this.formAction = "edit";
            this.Dialog = true;
            break;
          default:
            this.Form = {};
            this.formAction = "create";
            this.Dialog = true;
            break;
        }
      } else {
        alert("Please Select a Portal before continuing.");
      }
    },
    emptyForm() {
      this.Dialog = true;
      this.formAction = "create";
      this.Form = {}
    },
    readPortals() {
      this.$store.dispatch("Admin/readPortals");
      this.portalDialog = true;
    },
    readLookups() {
      this.$store.dispatch("Admin/readLookups", [this.portal.active.id]);
    }
  }
};
</script>

<style>
h1 {
  font-size: 30px !important;
}
.tablerowheight {
  height: 25px !important;
  font-size: 13px !important;
}
.tableicon {
  font-size: 20px !important;
}
.hidden {
  display: none;
}
.vgt-global-search__actions {
  margin-left: 50px !important;
}
.vgt-global-search__input {
  padding-top: 10px !important;
}
.v-list__tile__title {
  height: 25px !important;
}
.v-input--selection-controls.v-input .v-label {
  top: 4px !important;
}
</style>
